<template>
  <span class="table-matric">
    <router-link
      v-if="isLink && navigateTo"
      class="text-decoration-none"
      :class="textClass"
      :to="{ path: navigateTo, query }"
    >
      {{ text }}
    </router-link>
    <span
      v-else-if="text"
      @click="onTextClick"
      :class="[{ 'cursor-pointer': isTextPointer }, textClass]"
      class="body-2"
    >
      {{ text }}
    </span>
  </span>
</template>

<script>
/**
 * Renders the table row matric (spam, inbox, missing, text) details
 */
export default {
  name: "TableMatricsRow",
  /**
   * ---------------- Custom events ------------------
   */
  emits: ["click"],
  /**
   * ---------------- Props ------------------
   */
  props: {
    /**
     * Text to be displayed
     */
    text: {
      type: [String, Number],
      default: "",
    },
    textClass: { type: String, default: "text--primary" },
    isTextPointer: { type: Boolean, default: false },
    /**
     * Route where user have to be redirected
     */
    navigateTo: { type: String, default: "" },
    /**
     * Route query params
     */
    query: { type: Object, default: () => ({}) },
    isLink: { type: Boolean, default: false },
  },
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {},
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    /**
     * Emits click event on text click
     * @emits click
     */
    onTextClick() {
      this.$emit("click");
    },
  },
};
</script>
